/* Modals */

// Additional functionality for video players in modals

if ($('.wex-modal-thumb')) {
  var counter = 0;
  $('.wex-modal-thumb').each(function(){
    counter++;
    var modalId = 'wexModal' + counter,
        embedFile = $(this).attr('data-embed-id'),
        audioFile = $(this).attr('data-audio-file'),
        modalHTML;

    if (audioFile == 'true') {
      modalHTML = $([
      '<div class="reveal wex-modal" id="' + modalId + '" data-reveal data-animation-in="fadeIn">',
        '<audio controls>',
          '<source src="'+ embedFile +'" type="audio/mp3">',
          '<p>Your browser doesn\'t support HTML5 audio. Here is a <a href="#">link to the audio</a> instead.</p>',
        '</audio>',
        '<button class="close-button" data-close aria-label="Close modal" type="button">',
          '<span aria-hidden="true">&times;</span>',
        '</button>',
      '</div>'
      ].join("\n"));
    } else {
      modalHTML = $([
      '<div class="reveal wex-modal" id="' + modalId + '" data-reveal data-animation-in="fadeIn">',
        '<div class="responsive-embed widescreen wex-video">',
          '<div class="wex-video_player" data-height="550" data-width="310" data-embed-id="'+ embedFile +'"></div>',
          '<div class="wex-video_overlay"></div>',
        '</div>',
        '<button class="close-button" data-close aria-label="Close modal" type="button">',
          '<span aria-hidden="true">&times;</span>',
        '</button>',
      '</div>'
      ].join("\n"));
    }
    
    $('body').append(modalHTML);
    $(this).attr('data-open', modalId);
    var elem = new Foundation.Reveal($('#' + modalId));

    // Adding functionality for keyboard to open modal
    $(this).keydown(function(event){
      // Move to previous focusable element
      if (event.keyCode === 13 || event.keyCode === 32) {
        $('#' + modalId).foundation('toggle');
      }
    });
  });
}